import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { STATUS_VALUE_OPTIONS } from '../optionValues';

export const PRIORITY_OPTIONS_DEU = [
  { value: 'High', label: 'Hoch' },
  { value: 'Medium', label: 'Mittel' },
  { value: 'Low', label: 'Niedrig' },
];

export const KEY_COMPETITORS_PRIORITY_OPTIONS_DEU = [
  { value: 'High', label: 'Hoch' },
  { value: 'Medium', label: 'Mittel' },
  { value: 'Low', label: 'Niedrig' },
];

export const TERMS_OPTIONS_DEU = [
  { value: 'longTerm', label: 'Langfristig' },
  { value: 'shortTerm', label: 'Kurzfristig' },
];

export const LIFE_CYCLE_STAGES_OPTIONS_DEU = [
  { label: 'Idee', value: 'Idea' },
  { label: 'F&E', value: 'R&D' },
  { label: 'Wachstum', value: 'Growth' },
  { label: 'Reifephase', value: 'Maturity' },
];

export const PROJECT_STATUS_OPTIONS_DEU = [
  { value: 'Idea Assessment', label: 'Ideenbewertung' },
  { value: 'Research and Development', label: 'Forschung und Entwicklung' },
  { value: 'Evaluation and Selection', label: 'Bewertung und Auswahl' },
  { value: 'Financing', label: 'Finanzierung' },
  { value: 'Implementation', label: 'Implementierung' },
  { value: 'Operation and Management', label: 'Betrieb und Management' },
];

export const FUNDING_DIRECTIONS_OPTIONS_DEU = [
  { label: 'Forschung und Entwicklung (F&E)', value: 'Research and Development (R&D)' },
  { label: 'Marketing und Vertrieb', value: 'Marketing and Sales' },
  { label: 'Betriebskapital', value: 'Working Capital' },
  { label: 'Bau von Gebäuden und Anlagen', value: 'Construction of Buildings and Facilities' },
  { label: 'Kauf von Ausrüstung', value: 'Purchase of Equipment' },
];

export const STATUS_OPTIONS_DEU = [
  { value: STATUS_VALUE_OPTIONS.DONE, label: 'Abgeschlossen' },
  { value: STATUS_VALUE_OPTIONS.IN_PROGRESS, label: 'In Arbeit' },
  { value: STATUS_VALUE_OPTIONS.TO_DO, label: 'Zu erledigen' },
];

export const GENDER_OPTIONS_DEU = [
  { value: 'Male', label: 'Männlich' },
  { value: 'Female', label: 'Weiblich' },
  { value: 'Gender-Neutral', label: 'Geschlechtsneutral' },
];

export const PRODUCT_SERVICE_OPTIONS_DEU = [
  { value: 'Product/Service', label: 'Produkt/Dienstleistung' },
  { value: 'Region', label: 'Region' },
  { value: 'Market Segment', label: 'Marktsegment' },
];

export const CONSUMER_OPTIONS_DEU = [
  { value: 'Product', label: 'Produkt' },
  { value: 'Service', label: 'Dienstleistung' },
  { value: 'Consumer', label: 'Verbraucher' },
  { value: 'Producer', label: 'Produzent' },
  { value: 'Other Market Segment', label: 'Anderes Marktsegment' },
];

export const UNITS_VALUES_DEU = {
  // tomorrow
  VOLUME_IN: 'Volumen in',
  CURRENCY: 'Währung',
} as const;

export const PREMISE_TERMS_OF_USE_OPTIONS_DEU = [
  { value: 'Ownership', label: 'Eigentum' },
  { value: 'Renting', label: 'Miete' },
  { value: 'Leasing', label: 'Leasing' },
  { value: 'Shared Ownership', label: 'Teileigentum' },
];

export const DELIVERY_TERMS_OPTIONS_DEU = [
  { value: 'Prepayment', label: 'Vorkasse' },
  { value: 'Upon delivery', label: 'Bei Lieferung' },
  { value: 'Deferred payment', label: 'Zahlungsaufschub' },
];

export const RISKS_OPTIONS_DEU = [
  { value: 'marketRisks', label: 'Marktrisiken' },
  { value: 'operationalRisks', label: 'Operationelle Risiken' },
  { value: 'financialRisks', label: 'Finanzielle Risiken' },
  { value: 'legalAndRegulatoryRisks', label: 'Rechtliche und regulatorische Risiken' },
  { value: 'technologicalRisks', label: 'Technologische Risiken' },
  { value: 'humanResourceRisks', label: 'Personalrisiken' },
  { value: 'environmentalRisks', label: 'Umweltrisiken' },
  { value: 'other', label: 'Andere' },
];

export const ONE_PAGE_OPTIONS_DEU = [
  { label: 'Kurz', value: BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT },
  { label: 'Erweitert', value: BUSINESS_PLAN_TYPES.ONE_PAGE },
];
